export default 'https://tme.understood.org/assets/rule.0bb7761e.jpg'